import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Stack, Heading } from '@chakra-ui/react'
import AddressFields from '/overrides/app/components/forms/address-fields'
import { useForm } from 'react-hook-form'
import { useTranslationHelpers } from '@epmc-mach/accelarator/overrides/app/hooks'
import { useCustomerLocation } from '@epmc-mach/accelarator/overrides/app/contexts/CustomerLocation'

const BillingAddressForm = ({ address, onCancel, hasSavedAddresses, form }) => {
    const { tFormLabels } = useTranslationHelpers()
    const { defaultCountryCode } = useCustomerLocation()

    // Use provided form or create fallback
    const addressForm =
        form ||
        useForm({
            mode: 'onChange',
            shouldUnregister: false
        })

    useEffect(() => {
        if (address) {
            // Edit mode - fill form with billing_ prefix
            const formData = {
                addressId: address.addressId || ''
            }

            Object.keys(address).forEach((key) => {
                if (
                    ![
                        'addressId',
                        'creationDate',
                        'lastModified',
                        'preferred',
                        'fullName'
                    ].includes(key)
                ) {
                    formData[`billing_${key}`] = address[key]
                }
            })

            addressForm.reset(formData)
        } else {
            // New address mode - empty form
            addressForm.reset({
                addressId: '',
                billing_firstName: '',
                billing_lastName: '',
                billing_address1: '',
                billing_address2: '',
                billing_c_address3: '',
                billing_city: '',
                billing_postalCode: '',
                billing_countryCode: defaultCountryCode,
                billing_phone: '',
                billing_companyName: ''
            })
        }
    }, [address, addressForm])

    return (
        <Box
            gridColumn={hasSavedAddresses ? [1, 1, 'span 2'] : 1}
            paddingY={hasSavedAddresses ? 6 : 0}
        >
            <Stack spacing={6}>
                {hasSavedAddresses && (
                    <Heading as="h3" size="md">
                        {address
                            ? tFormLabels?.editBillingAddress
                            : tFormLabels?.addNewBillingAddress}
                    </Heading>
                )}

                <Stack spacing={6}>
                    <AddressFields form={addressForm} isBillingAddress={true} />
                </Stack>
            </Stack>
        </Box>
    )
}

BillingAddressForm.propTypes = {
    address: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    hasSavedAddresses: PropTypes.bool,
    form: PropTypes.object
}

export default BillingAddressForm
